import type { MaybeRefOrGetter } from 'vue';
import type { ResolvedMonospaceCollection } from '#layers/data-model/types/schema/resolved-schema';
import type { QuerySchemaCollection } from '#layers/data-model/utils/schema/query-schema';
import { computed, toValue } from 'vue';
import { useWorkspaceSchemaStore } from '#layers/data-model/stores/workspace-schema';
import { mapQueryCapability, queryCapabilityAllows, resolveCollectionQueryCapability } from '#layers/data-model/utils/schema/query-capability';

/** System collections use their known contracts; a workspace schema that is not loaded fails closed. */
export function useQueryApi(collection: MaybeRefOrGetter<Pick<ResolvedMonospaceCollection, 'id' | 'isSystem'> | null | undefined>) {
	const workspaceSchema = useWorkspaceSchemaStore();
	const api = computed(() => resolveCollectionQueryCapability(toValue(collection), workspaceSchema.querySchema));

	function supports(predicate: (api: QuerySchemaCollection) => boolean) {
		return computed(() => queryCapabilityAllows(api.value, predicate));
	}

	function surface<T extends object>(pick: (api: QuerySchemaCollection) => T | undefined) {
		return computed(() => mapQueryCapability(api.value, pick));
	}

	return { api, supports, surface };
}
